(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("BackToTop");

  Components.create('BackToTop', {

    sizes: {},

    setSizes: function() {
      if ($('.back-to-top').length == 0) {
        return;
      }
      

      this.sizes = {
        initialOffset: 200,
        bottomOffset: 60,
        footerTop: $('footer.main').offset().top,
        initialBottom: parseFloat( $('.back-to-top').css('bottom'), 10 )
      };

      logger.d("Sizes set:", this.sizes);
    },

    bindEvents: function() {

      App.Window.on('scroll', function(e) {
        var
          scrollTop = App.Window.scrollTop(),
          scrollBottom = scrollTop + App.Window.height() + Components.BackToTop.sizes.bottomOffset;

        if ( scrollTop > Components.BackToTop.sizes.initialOffset ) {
          $('.back-to-top').addClass('in');
        } else {
          $('.back-to-top').removeClass('in');
        }

        if ( Components.BackToTop.sizes.footerTop < scrollBottom ) {
          var bottom = scrollBottom - Components.BackToTop.sizes.footerTop + Components.BackToTop.sizes.initialBottom;
          $('.back-to-top').css('bottom', bottom);
        } else {
          $('.back-to-top').css('bottom', "");
        }

      });

      $('.back-to-top').on('click', function(){
        App.HtmlBody.animate({ scrollTop: 0 }, 1000 );
        return false;
      });

    },

    onResize: function() {
      this.setSizes();
    },

    init: function() {
      this.onResize();
      this.bindEvents();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
